export const tokens = {
  colors: {
    bgGradientStart: '#B72DA4',
    bgGradientEnd: '#CE2961',
    primary: '#B72DA4',
    secondary: '#CE2961',
    accent: '#06B6D4',
    success: '#22C55E',
    warning: '#F59E0B',
    error: '#EF4444',
    text: '#0B1220',
    textOnDark: '#FFFFFF',
    surface: '#FFFFFF',
    surfaceMuted: '#F8FAFC',
    border: '#E2E8F0',
    // Cores padrão do sistema para admin
    adminBg: '#F8F9FA',
    adminSurface: '#FFFFFF',
    adminText: '#212529',
    adminTextMuted: '#6C757D',
    adminBorder: '#DEE2E6',
    adminAccent: '#B72DA4' // Rosa padrão do sistema
  },
  typography: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    h1: { size: '32px', line: '40px', weight: 700 },
    h2: { size: '24px', line: '32px', weight: 700 },
    h3: { size: '20px', line: '28px', weight: 600 },
    body: { size: '16px', line: '24px', weight: 400 },
    caption: { size: '13px', line: '20px', weight: 400 }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
    xxxl: '48px',
    huge: '64px'
  },
  radius: {
    xs: '6px',
    md: '12px',
    lg: '20px'
  },
  shadow: {
    sm: '0 2px 8px rgba(0,0,0,0.08)',
    md: '0 8px 24px rgba(0,0,0,0.12)',
    lg: '0 16px 40px rgba(0,0,0,0.16)'
  },
  breakpoints: {
    sm: '480px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
  }
};

export type AppTheme = typeof tokens;